import React, { FunctionComponent } from "react";
import { Box, Typography } from "@mui/material";
import styles from "./CardHead.module.css";
import {
	colorAvocado,
	colorDragonFruit,
	colorLime,
	colorMelon,
	colorPotato,
} from "../../styles/theme";

interface RelevancyScoreProps {
	score: number;
	height?: string;
}

const RelevancyScore: FunctionComponent<RelevancyScoreProps> = ({
	score,
	height = "60px",
}) => {
	const color = getColor(score);

	return (
		<Box
			className={styles.scoreBox}
			sx={{ backgroundColor: color, height: height, borderRadius: "10px" }}
		>
			<Typography sx={{ color: "white", fontSize: "22px", fontWeight: "500" }}>
				{score}
			</Typography>
			<Typography sx={{ color: "white", fontSize: "14px", paddingTop: "6px" }}>
				%
			</Typography>
		</Box>
	);
};

export default RelevancyScore;

const getColor = (relevancy: number) => {
	if (relevancy < 40) {
		return colorDragonFruit;
	}
	if (relevancy < 55) {
		return colorAvocado;
	}
	if (relevancy < 70) {
		return colorPotato;
	}
	if (relevancy < 85) {
		return colorMelon;
	}
	return colorLime;
};
